/* eslint-disable */
'use strict';
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/*
 * Web Bluetooth DFU
 * Copyright (c) 2018 Rob Moran
 *
 * The MIT License (MIT)
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var __extends = (this && this.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                    ({ __proto__: [] } instanceof Array &&
                        function (d, b) {
                            d.__proto__ = b;
                        }) ||
                    function (d, b) {
                        for (var p in b)
                            if (b.hasOwnProperty(p))
                                d[p] = b[p];
                    };
            return extendStatics(d, b);
        };
        return function (d, b) {
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __assign = (this && this.__assign) ||
    function () {
        __assign =
            Object.assign ||
                function (t) {
                    for (var s, i = 1, n = arguments.length; i < n; i++) {
                        s = arguments[i];
                        for (var p in s)
                            if (Object.prototype.hasOwnProperty.call(s, p))
                                t[p] = s[p];
                    }
                    return t;
                };
        return __assign.apply(this, arguments);
    };
Object.defineProperty(exports, '__esModule', { value: true });
exports.SecureDfu = void 0;
var DeviceStateEnum = require('../src/features/firmwareManager/enum/device-state.enum').DeviceStateEnum;
var lastErrorCode;
var deviceState = DeviceStateEnum.DFU_PROCESS_STARTED;
var dispatcher_1 = require('./dispatcher');
var CONTROL_UUID = '8EC90001-F315-4F60-9FB8-838830DAEA50';
var PACKET_UUID = '8EC90002-F315-4F60-9FB8-838830DAEA50';
var BUTTON_UUID = '8EC90003-F315-4F60-9FB8-838830DAEA50';
var LITTLE_ENDIAN = true;
var PACKET_SIZE = 32;
var OPERATIONS = {
    BUTTON_COMMAND: [0x01],
    CREATE_COMMAND: [0x01, 0x01],
    CREATE_DATA: [0x01, 0x02],
    RECEIPT_NOTIFICATIONS: [0x02],
    CACULATE_CHECKSUM: [0x03],
    EXECUTE: [0x04],
    SELECT_COMMAND: [0x06, 0x01],
    SELECT_DATA: [0x06, 0x02],
    RESPONSE: [0x60, 0x20],
};
var RESPONSE = {
    // Invalid code
    0x00: 'Invalid opcode',
    // Success
    0x01: 'Operation successful',
    // Opcode not supported
    0x02: 'Opcode not supported',
    // Invalid parameter
    0x03: 'Missing or invalid parameter value',
    // Insufficient resources
    0x04: 'Not enough memory for the data object',
    // Invalid object
    0x05: 'Data object does not match the firmware and hardware requirements, the signature is wrong, or parsing the command failed',
    // Unsupported type
    0x07: 'Not a valid object type for a Create request',
    // Operation not permitted
    0x08: 'The state of the DFU process does not allow this operation',
    // Operation failed
    0x0a: 'Operation failed',
    // Extended error
    0x0b: 'Extended error',
    // 
    0x0e: 'Corrupted firmware'
};
var EXTENDED_ERROR = {
    // No error
    0x00: 'No extended error code has been set. This error indicates an implementation problem',
    // Invalid error code
    0x01: 'Invalid error code. This error code should never be used outside of development',
    // Wrong command format
    0x02: 'The format of the command was incorrect',
    // Unknown command
    0x03: 'The command was successfully parsed, but it is not supported or unknown',
    // Init command invalid
    0x04: 'The init command is invalid. The init packet either has an invalid update type or it is missing required fields for the update type',
    // Firmware version failure
    0x05: 'The firmware version is too low. For an application, the version must be greater than the current application. For a bootloader, it must be greater than or equal to the current version',
    // Hardware version failure
    0x06: 'The hardware version of the device does not match the required hardware version for the update',
    // Softdevice version failure
    0x07: 'The array of supported SoftDevices for the update does not contain the FWID of the current SoftDevice',
    // Signature missing
    0x08: 'The init packet does not contain a signature',
    // Wrong hash type
    0x09: 'The hash type that is specified by the init packet is not supported by the DFU bootloader',
    // Hash failed
    0x0a: 'The hash of the firmware image cannot be calculated',
    // Wrong signature type
    0x0b: 'The type of the signature is unknown or not supported by the DFU bootloader',
    // Verification failed
    0x0c: 'The hash of the received firmware image does not match the hash in the init packet',
    // Insufficient space
    0x0d: 'The available space on the device is insufficient to hold the firmware',
};
/**
 * Secure Device Firmware Update class
 */
var SecureDfu = /** @class */ (function (_super) {
    __extends(SecureDfu, _super);
    /**
     * Characteristic constructor
     * @param bluetooth A bluetooth instance
     * @param crc32 A CRC32 function
     * @param delay Milliseconds of delay between packets
     */
    function SecureDfu(crc32, bluetooth, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        var _this = _super.call(this) || this;
        _this.crc32 = crc32;
        _this.bluetooth = bluetooth;
        _this.delay = delay;
        _this.DEFAULT_UUIDS = {
            service: SecureDfu.SERVICE_UUID,
            button: BUTTON_UUID,
            control: CONTROL_UUID,
            packet: PACKET_UUID,
        };
        _this.notifyFns = {};
        _this.controlChar = null;
        _this.packetChar = null;
        _this.dfuModeOn = false;
        if (!_this.bluetooth && window && window.navigator && window.navigator.bluetooth) {
            _this.bluetooth = navigator.bluetooth;
        }
        return _this;
    }
    SecureDfu.prototype.log = function (message) {
        var _this = this;
        this.dispatchEvent(SecureDfu.EVENT_LOG, {
            message: message,
            dfuModeOn: _this.dfuModeOn
        });
    };
    SecureDfu.prototype.progress = function (bytes) {
        this.dispatchEvent(SecureDfu.EVENT_PROGRESS, {
            object: 'unknown',
            totalBytes: 0,
            currentBytes: bytes,
        });
    };
    SecureDfu.prototype.connect = function (device, dfuModeOn) {
        var _this = this;
        device.addEventListener('gattserverdisconnected', function () {
            _this.notifyFns = {};
            _this.controlChar = null;
            _this.packetChar = null;
            _this.log("Device Disconnected...");
        });
        var uuids = __assign(__assign({}, this.DEFAULT_UUIDS), uuids);
        this.DEFAULT_UUIDS = uuids;
        return this.gattConnect(device, uuids.service, dfuModeOn)
            .then(function (characteristics) {
            _this.log('found ' + characteristics.length + ' characteristic(s)');
            _this.packetChar = characteristics.find(function (characteristic) {
                _this.log("Searching Packet UUID " + characteristic.uuid);
                return characteristic.uuid.toLowerCase() === uuids.packet.toLowerCase();
            });
            if (!_this.packetChar)
                throw new Error('Unable to find packet characteristic');
            _this.log('found packet characteristic');
            _this.controlChar = characteristics.find(function (characteristic) {
                _this.log("Searching Control UUID " + characteristic.uuid);
                return characteristic.uuid.toLowerCase() === uuids.control.toLowerCase();
            });
            if (!_this.controlChar)
                throw new Error('Unable to find control characteristic');
            _this.log('found control characteristic');
            // TODO: Add check only for Bat browser
            // if (!_this.controlChar.properties.notify && !_this.controlChar.properties.indicate) {
            //     throw new Error('Control characteristic does not allow notifications');
            // }
            return _this.controlChar.startNotifications();
        })
            .then(function () { return _this.delayPromise(1000); })
            .then(function () {
            _this.controlChar.addEventListener('characteristicvaluechanged', _this.handleNotification.bind(_this));
            _this.log('enabled control notifications');
            return device;
        }).catch(function (e) {
            _this.log("Error connecting to DFU Targ" + e.message);
            _this.setLastError(0x0e);
            _this.setDeviceState(DeviceStateEnum.DFU_COMPLETED);
            throw new Error("Cannot connect to DFUTarg");
        });
    };
    SecureDfu.prototype.gattConnect = function (device, serviceUUID, dfuModeOn) {
        var _this = this;
        if (serviceUUID === void 0) {
            serviceUUID = SecureDfu.SERVICE_UUID;
        }
        var characteristics = [];
        return Promise.resolve()
            .then(function (resolve) {
            try {
                if (device.gatt.connected)
                    return device.gatt;
                return device.gatt.connect();
            }
            catch (_a) {
                _this.setLastError(0x0e);
                _this.setDeviceState(DeviceStateEnum.DFU_COMPLETED);
            }
        })
            .then(function (gattServer) {
            return new Promise(function (resolve) {
                setTimeout(function () {
                    resolve(gattServer);
                }, 1000);
            });
        })
            .then(function (server) {
            _this.log('connected to gatt server');
            return server.getPrimaryService(serviceUUID).catch(function () {
                throw new Error('Unable to find DFU service');
            });
        })
            .then(function (service) {
            _this.log('found DFU service');
            var characteristics = [];
            if (dfuModeOn) {
                _this.dfuModeOn = true;
                _this.log("DFU Mode On, Getting Control and Packet Chars");
                characteristics.push(service.getCharacteristic(_this.DEFAULT_UUIDS.control.toLowerCase()));
                characteristics.push(service.getCharacteristic(_this.DEFAULT_UUIDS.packet.toLowerCase()));
            }
            if (!dfuModeOn) {
                _this.log("DFU Mode Off, Getting Button Less Char");
                characteristics.push(service.getCharacteristic(_this.DEFAULT_UUIDS.button.toLowerCase()));
            }
            return Promise.all(characteristics);
        })
            .then(function (values) {
            _this.log("Values for Characterstis " + values.length + " Mode " + dfuModeOn);
            return values;
        });
    };
    SecureDfu.prototype.handleNotification = function (event) {
        var view = event.target.value;
        if (OPERATIONS.RESPONSE.indexOf(view.getUint8(0)) < 0) {
            throw new Error('Unrecognised control characteristic response notification');
        }
        var operation = view.getUint8(1);
        if (this.notifyFns[operation]) {
            var result = view.getUint8(2);
            var error = null;
            if (result === 0x01) {
                var data = new DataView(view.buffer, 3);
                this.notifyFns[operation].resolve(data);
            }
            else if (result === 0x0b) {
                var code = view.getUint8(3);
                error = 'Error: ' + EXTENDED_ERROR[code];
            }
            else {
                error = 'Error: ' + RESPONSE[result];
            }
            if (error) {
                this.setLastError(result);
                this.log('notify: ' + error);
                this.notifyFns[operation].reject(error);
            }
            delete this.notifyFns[operation];
        }
    };
    SecureDfu.prototype.sendOperation = function (characteristic, operation, buffer) {
        return __awaiter(this, void 0, void 0, function () {
            var _this;
            return __generator(this, function (_a) {
                try {
                    _this = this;
                    return [2 /*return*/, new Promise(function (resolve, reject) {
                            return __awaiter(this, void 0, void 0, function () {
                                var size, value, data;
                                return __generator(this, function (_a) {
                                    size = operation.length;
                                    if (buffer)
                                        size += buffer.byteLength;
                                    value = new Uint8Array(size);
                                    value.set(operation);
                                    if (buffer) {
                                        data = new Uint8Array(buffer);
                                        value.set(data, operation.length);
                                    }
                                    _this.notifyFns[operation[0]] = {
                                        resolve: resolve,
                                        reject: reject,
                                    };
                                    //_this.log("Sending OpCode "+value.toString());
                                    characteristic.writeValue(value).catch(function (e) {
                                        return (Promise.resolve()
                                            .then(function () {
                                            return _this.delayPromise(500);
                                        })
                                            // Retry once
                                            .then(function () {
                                            return characteristic.writeValue(value);
                                        }).catch(function (e) {
                                            _this.log("Send Op Error " + e + " for value " + value);
                                            reject(e);
                                        }));
                                    });
                                    return [2 /*return*/];
                                });
                            });
                        })];
                }
                catch (error) {
                    throw error;
                }
                return [2 /*return*/];
            });
        });
    };
    SecureDfu.prototype.sendControl = function (operation, buffer) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            //_this.log(_this.controlChar.uuid);
            _this.sendOperation(_this.controlChar, operation, buffer).then(function (resp) {
                setTimeout(function () {
                    return resolve(resp);
                }, _this.delay);
            }).catch(function (e) {
                reject(e);
            });
        });
    };
    SecureDfu.prototype.transferInit = function (buffer) {
        return this.transfer(buffer, 'init', OPERATIONS.SELECT_COMMAND, OPERATIONS.CREATE_COMMAND);
    };
    SecureDfu.prototype.transferFirmware = function (buffer) {
        return this.transfer(buffer, 'firmware', OPERATIONS.SELECT_DATA, OPERATIONS.CREATE_DATA);
    };
    SecureDfu.prototype.transfer = function (buffer, type, selectType, createType) {
        var _this = this;
        return this.sendControl(selectType).then(function (response) {
            var maxSize = response.getUint32(0, LITTLE_ENDIAN);
            var offset = response.getUint32(4, LITTLE_ENDIAN);
            var crc = response.getInt32(8, LITTLE_ENDIAN);
            if (type === 'init' && offset === buffer.byteLength && _this.checkCrc(buffer, crc)) {
                _this.log('init packet already available, skipping transfer');
                return;
            }
            _this.progress = function (bytes) {
                _this.dispatchEvent(SecureDfu.EVENT_PROGRESS, {
                    object: type,
                    totalBytes: buffer.byteLength,
                    currentBytes: bytes,
                });
            };
            _this.progress(0);
            return _this.transferObject(buffer, createType, maxSize, offset, type);
        });
    };
    SecureDfu.prototype.transferObject = function (buffer, createType, maxSize, offset, type) {
        var _this = this;
        var start = offset - (offset % maxSize);
        var end = Math.min(start + maxSize, buffer.byteLength);
        var view = new DataView(new ArrayBuffer(4));
        view.setUint32(0, end - start, LITTLE_ENDIAN);
        return this.sendControl(createType, view.buffer)
            .then(function () {
            var data = buffer.slice(start, end);
            return _this.transferData(data, start);
        })
            .then(function () {
            return _this.sendControl(OPERATIONS.CACULATE_CHECKSUM);
        })
            .then(function (response) {
            var crc = response.getInt32(4, LITTLE_ENDIAN);
            var transferred = response.getUint32(0, LITTLE_ENDIAN);
            var data = buffer.slice(0, transferred);
            if (_this.checkCrc(data, crc)) {
                _this.log('written ' + transferred + ' bytes');
                offset = transferred;
                return _this.sendControl(OPERATIONS.EXECUTE);
            }
            else {
                _this.log('object failed to validate...retrying');
            }
        })
            .then(function () {
            if (end < buffer.byteLength) {
                return _this.transferObject(buffer, createType, maxSize, offset, type);
            }
            else {
                _this.log('transfer complete');
                if (type === "firmware") {
                    _this.dfuModeOn = false;
                }
                return _this.delayPromise(500);
            }
        });
    };
    SecureDfu.prototype.transferData = function (data, offset, start) {
        var _this = this;
        start = start || 0;
        var end = Math.min(start + PACKET_SIZE, data.byteLength);
        var packet = data.slice(start, end);
        return this.packetChar
            .writeValue(packet)
            .then(function () {
            return _this.delayPromise(_this.delay);
        })
            .then(function () {
            _this.progress(offset + end);
            if (end < data.byteLength) {
                return _this.transferData(data, offset, end);
            }
        });
    };
    SecureDfu.prototype.checkCrc = function (buffer, crc) {
        if (!this.crc32) {
            this.log('crc32 not found, skipping CRC check');
            return true;
        }
        return crc === this.crc32(new Uint8Array(buffer));
    };
    SecureDfu.prototype.delayPromise = function (delay) {
        return new Promise(function (resolve) {
            setTimeout(resolve, delay);
        });
    };
    /**
     * Scans for a device to update
     * @param buttonLess Scans for all devices and will automatically call `setDfuMode`
     * @param filters Alternative filters to use when scanning
     * @param uuids Optional alternative uuids for service, control, packet or button
     * @returns Promise containing the device
     */
    SecureDfu.prototype.requestDevice = function (buttonLess, filters, uuids) {
        var _this = this;
        if (uuids === void 0) {
            uuids = this.DEFAULT_UUIDS;
        }
        uuids = __assign(__assign({}, this.DEFAULT_UUIDS), uuids);
        this.DEFAULT_UUIDS = uuids;
        if (!buttonLess && !filters) {
            filters = [{ services: [uuids.service] }];
        }
        var options = {
            optionalServices: [uuids.service],
        };
        if (filters)
            options.filters = filters;
        else
            options.acceptAllDevices = true;
        return this.bluetooth.requestDevice(options).then(function (device) {
            if (buttonLess) {
                return _this.setDfuMode(device, uuids);
            }
            return device;
        });
    };
    /**
     * Sets the DFU mode of a device, preparing it for update
     * @param device The device to switch mode
     * @param uuids Optional alternative uuids for control, packet or button
     * @returns Promise containing the device if it is still on a valid state
     */
    SecureDfu.prototype.setDfuMode = function (device, uuids) {
        var _this = this;
        if (uuids === void 0) {
            uuids = this.DEFAULT_UUIDS;
        }
        uuids = __assign(__assign({}, this.DEFAULT_UUIDS), uuids);
        this.DEFAULT_UUIDS = uuids;
        return this.gattConnect(device, uuids.service, false).then(function (characteristics) {
            _this.log('found ' + characteristics.length + ' characteristic(s)');
            var controlChar = characteristics.find(function (characteristic) {
                return characteristic.uuid.toLowerCase() === uuids.control.toLowerCase();
            });
            var packetChar = characteristics.find(function (characteristic) {
                return characteristic.uuid.toLowerCase() === uuids.packet.toLowerCase();
            });
            if (controlChar && packetChar) {
                return device;
            }
            var buttonChar = characteristics.find(function (characteristic) {
                _this.log("Searching Button UUID " + characteristic.uuid);
                return characteristic.uuid.toLowerCase() === uuids.button.toLowerCase();
            });
            if (!buttonChar) {
                throw new Error('Unsupported device');
            }
            _this.buttonChar = buttonChar;
            // Support buttonless devices
            _this.log('found buttonless characteristic');
            // TODO: Add check only for Bat browser
            // if (!buttonChar.properties.notify && !buttonChar.properties.indicate) {
            //     throw new Error('Buttonless characteristic does not allow notifications');
            // }
            return new Promise(function (resolve, _reject) {
                function complete() {
                    this.notifyFns = {};
                    _this.log("Server Disconnected...Reconnecting");
                    // Resolve with null device as it needs reconnecting
                    resolve(null);
                }
                buttonChar
                    .startNotifications()
                    .then(function () {
                    _this.log('enabled buttonless notifications');
                    device.addEventListener('gattserverdisconnected', complete.bind(_this));
                    buttonChar.addEventListener('characteristicvaluechanged', _this.handleNotification.bind(_this));
                    return _this.sendOperation(buttonChar, OPERATIONS.BUTTON_COMMAND);
                })
                    .then(function () {
                    _this.dfuModeOn = true;
                    _this.log('sent DFU mode');
                    complete.bind(_this)();
                }).catch(function (e) {
                    _reject(e);
                });
            });
        });
    };
    SecureDfu.prototype.setLastError = function (error) {
        this.lastErrorCode = error;
    };
    SecureDfu.prototype.getLastError = function () {
        return this.lastErrorCode;
    };
    SecureDfu.prototype.setDeviceState = function (state) {
        this.deviceState = state;
    };
    SecureDfu.prototype.getDeviceState = function () {
        return this.deviceState;
    };
    /**
     * Updates a device
     * @param device The device to switch mode
     * @param init The initialisation packet to send
     * @param firmware The firmware to update
     * @returns Promise containing the device
     */
    SecureDfu.prototype.update = function (device, init, firmware, skipDfuMode) {
        var _this = this;
        if (skipDfuMode === true)
            _this.dfuModeOn = true;
        return new Promise(function (resolve, reject) {
            if (!device)
                return reject('Device not specified');
            if (!init)
                return reject('Init not specified');
            if (!firmware)
                return reject('Firmware not specified');
            _this
                .connect(device, true)
                .then(function () {
                _this.log('transferring init');
                return _this.transferInit(init);
            })
                .then(function () {
                _this.log('transferring firmware');
                return _this.transferFirmware(firmware);
            })
                .then(function () {
                _this.log('complete, disconnecting...');
                //return device.gatt.disconnect();
                device.addEventListener('gattserverdisconnected', function () {
                    _this.log('disconnected');
                    resolve(device);
                });
            })
                .then(function () {
                return resolve(device);
            })
                .catch(function (error) {
                device.gatt.disconnect();
                return reject(error);
            });
        });
    };
    /**
     * DFU Service unique identifier
     */
    SecureDfu.SERVICE_UUID = "0000fe59-0000-1000-8000-00805f9b34fb";
    /**
     * Log event
     * @event
     */
    SecureDfu.EVENT_LOG = 'log';
    /**
     * Progress event
     * @event
     */
    SecureDfu.EVENT_PROGRESS = 'progress';
    return SecureDfu;
})(dispatcher_1.EventDispatcher);
exports.SecureDfu = SecureDfu;
